import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export const LanguageSwitch = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-1 bg-gray-800/50 rounded-full p-1 border border-gray-700">
      <button
        data-testid="lang-fr"
        onClick={() => setLanguage('fr')}
        className={`px-3 py-1 rounded-full text-sm font-medium transition-all ${
          language === 'fr'
            ? 'bg-orange-500 text-white'
            : 'text-gray-400 hover:text-white'
        }`}
      >
        FR
      </button>
      <button
        data-testid="lang-en"
        onClick={() => setLanguage('en')}
        className={`px-3 py-1 rounded-full text-sm font-medium transition-all ${
          language === 'en'
            ? 'bg-orange-500 text-white'
            : 'text-gray-400 hover:text-white'
        }`}
      >
        EN
      </button>
    </div>
  );
};
